<template>
  <div class="ticketCrudComp">

    <div>
      <label class="label_title" for="">ID кресла</label>
      <dropdown-comp :disabled="role != 'admin'" :moduleName="'kontrollers'" :value="data.kontrollerIdMysql.value"
                     :class="{'animated shake error_input': errors.kontrollerIdMysql}"
                     v-on:click.native="resetError('kontrollerIdMysql')"/>
      <p class="p_err_min">{{ errors.kontrollerIdMysql }}</p>
    </div>
    <div>
      <label class="label_title" for="">Адрес</label>
      <input-comp disabled :classInput="'input_grey'" :value="data.address.value" v-model="data.address.value"/>
      <p class="p_err_min">{{ errors.dealerName }}</p>
    </div>
    <div>
      <label class="label_title" for="">Имя диллера</label>
      <input-comp disabled :classInput="'input_grey'" :value="data.dealerName.value" v-model="data.dealerName.value"/>
      <p class="p_err_min">{{ errors.dealerName }}</p>
    </div>
    <div>
      <label class="label_title" for="">ID диллера (MySql)</label>
      <input-comp disabled :classInput="'input_grey'" :value="data.dealerIdMysql.value"
                  v-model="data.dealerIdMysql.value"/>
      <p class="p_err_min">{{ errors.dealerIdMysql }}</p>
    </div>
    <div class="div_btns">
      <button-comp :disabled="role != 'admin'" :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
    </div>

    <div>
      <label class="label_title" for="">Ответ тех.поддержки</label>
      <textarea cols="30" rows="10" :disabled="data.isClose.value" v-model="data.answer.value"
                :class="['textarea_grey', {'animated shake error_input':errors.answer}]"
                @click="resetError('answer')"></textarea>
      <p class="p_err_min">{{ errors.answer }}</p>
    </div>

    <div v-show="data.isClose.value != true">
      <label class="label_title" for="">Начислить бонусы пользователю, бонус.</label>
      <input type="number" min="0" :class="['input_grey', {'animated shake error_input':errors.bonus}]"
             @click="resetError('bonus')" v-model.number="bonus">
      <p class="p_err_min">{{ errors.bonus }}</p>
    </div>

    <div v-show="data.isClose.value != true && data.kontrollerIdMysql.value">
      <label class="label_title" for="">Запус массажа, мин.</label>
      <select v-model="currentProgram" class="select_grey">
        <option v-for="(program, index) in programs" :key="index" :value="program.countMinutes">
          {{ program.countMinutes }}
        </option>
      </select>
    </div>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Закрыть обращение'" v-show="data.isClose.value != true"
                   :clickBtn="close"/>
    </div>

    <p class="p_err_main">{{ errMain }}</p>

  </div>
</template>

<script>
export default {
  name: 'ticketCrudComp',
  props: {},
  data: function () {
    return {
      required: null,
      moduleName: 'tickets',
      users: {
        moduleName: 'users'
      },
      bonus: 0,
      currentProgram: 0
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  watch: {
    data () {
      if (this.data.kontrollerIdMysql.value) this.$store.dispatch(`${this.moduleName}/getPrograms`, { idMysql: this.data.kontrollerIdMysql.value })
    }
  },
  components: {},
  computed: {
    id: function () {
      return this.$store.getters[`${this.moduleName}/getId`]
    },
    data: function () {
      return this.$store.getters[`${this.moduleName}/getOne`]
    },
    errMain: function () {
      return this.$store.getters[`${this.moduleName}/getErrMain`]
    },
    errors: function () {
      return this.$store.getters[`${this.moduleName}/getErrors`]
    },
    role: function () {
      return localStorage.getItem('role')
    },
    programs: function () {
      return this.$store.getters[`${this.moduleName}/getPrograms`]
    }
  },
  methods: {
    save () {
      let data = {}
      data.id = this.id
      data.kontrollerIdMysql = this.$store.getters['kontrollers/getFinded']
      this.$store.dispatch(`${this.moduleName}/update`, { data: data, required: this.required })
    },
    remove () {
      this.$store.dispatch(`${this.moduleName}/delete`)
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    },
    close () {
      let dopAnswer = []
      let bonStr = this.$helpers.string.getWordEndingByCount(this.bonus, 'бонус', 'бонусов', 'бонуса')
      if (this.bonus) dopAnswer.push(`начиcлено: ${this.bonus} ${bonStr || ''}`)
      if (this.currentProgram) dopAnswer.push(`запущен массаж: ${this.currentProgram} мин. ${this.$helpers.date.format(new Date())}`)
      if (dopAnswer.length) this.data.answer.value += ` ( ${dopAnswer.join('; ')} )`
      this.$store.dispatch(`${this.moduleName}/close`, {
        data: this.data,
        required: this.required,
        bonus: this.bonus,
        userId: this.data.userId.value,
        countMinutes: this.currentProgram,
        idMysql: this.data.kontrollerIdMysql.value
      })
    }
  }
}
</script>

<style scoped lang="scss">

.ticketCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}

.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 32px;
  margin-top: 32px;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
  .promocodeCrudComp {
    width: calc(100% - 32px);
  }
}

@media screen and (max-width: 320px) {
}

</style>
